import {
    REQUEST_FORMS_DOWNLOAD,
    RECEIVE_FORMS_DOWNLOAD,
    ERROR_FORMS_DOWNLOAD
} from '../types'
import {initialFetchState} from '../../constants/defaultValues'
import {loadDataRefresh} from "../../constants/constants"

export default (state = initialFetchState, action = {}) => {
    switch(action.type) {
        case REQUEST_FORMS_DOWNLOAD:
            return {
                ...state,
                isFetching: true,
                message: '',
                errors: {}
            }
        case RECEIVE_FORMS_DOWNLOAD:
            return {
                ...state,
                isFetching: false,
                data: action.payload,
                validUntil: loadDataRefresh.default + Date.now(),
                message: '',
            }
        case ERROR_FORMS_DOWNLOAD:
            return {
                ...state,
                isFetching: false,
                errors: action.errors,
                message: action.errors.server || '',
            }
        default:
            return state
    }
}